// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgSticky = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color ?? 'currentColor'}
      d="M15.9 10.1 5.9.1C5.8 0 5.7 0 5.5 0h-5C.2 0 0 .2 0 .5v5c0 .1.1.3.1.4l10 10c.1.1.2.1.4.1s.3 0 .4-.1l5-5c.1-.2.1-.6 0-.8M3.7 3.7c-.4.4-1 .4-1.4 0s-.4-1 0-1.4 1-.4 1.4 0 .4 1 0 1.4"
    />
  </svg>
)
export default SvgSticky
